/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AccesscontrolControllers200,
  GetApiV1AccesscontrolControllers401,
  GetApiV1AccesscontrolControllers500,
  GetApiV1AccesscontrolControllersQueryResponse,
} from "../../types/accessControlControllersController/GetApiV1AccesscontrolControllers.ts";
import { controllerViewModelSchema } from "../controllerViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AccesscontrolControllers200Schema = z.array(
  z.lazy(() => controllerViewModelSchema),
) as unknown as ToZod<GetApiV1AccesscontrolControllers200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AccesscontrolControllers401Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolControllers401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AccesscontrolControllers500Schema =
  z.any() as unknown as ToZod<GetApiV1AccesscontrolControllers500>;

export const getApiV1AccesscontrolControllersQueryResponseSchema = z.lazy(
  () => getApiV1AccesscontrolControllers200Schema,
) as unknown as ToZod<GetApiV1AccesscontrolControllersQueryResponse>;
